import type { VoucherType } from "@/types/home-type";
import { CheckCircle2 } from "lucide-react";

export default function VoucherCardHome({
    vouchers,
    locale,
}: {
    vouchers: VoucherType[];
    locale: "id" | "en" | "my";
}) {
    return (
        <>
            {vouchers.map((v, i) => (
                <div
                    key={`home-voucher-card-${i}`}
                    className="bg-white dark:bg-white/5 border border-gold/20 dark:border-white/10 hover:border-gold dark:hover:border-gold/50 transition-colors rounded-2xl p-6 flex gap-5 items-center">
                    <div className="w-14 h-14 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0 text-gold">
                        <CheckCircle2 size={28} />
                    </div>
                    <div className="grow">
                        <h3 className="font-serif text-lg text-dark dark:text-white mb-1">
                            {v.title[locale]}
                        </h3>
                        <p className="text-[#5A4C33] dark:text-white/50 text-sm">
                            {v.desc ? v.desc[locale] : ""}
                        </p>
                    </div>
                    <div className="hidden sm:block shrink-0 bg-gold/30 hover:bg-gold dark:bg-gold dark:hover:bg-gold/30 text-dark text-xs font-bold px-3 py-1.5 rounded-full">
                        {v.code}
                    </div>
                </div>
            ))}
        </>
    );
}
